import { ReactNode } from "react";
import { ACCOUNT_ROLE_COPY } from "@common/constants/domains/accounting/accountRole";
import { AccountRole } from "@common/types/domains/accounting/account";
import {
    PlainModal,
    StandardModalFooter,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { InfoIcon } from "@icons";
import { REASSIGN_ROLE_OUTCOME_TOOLTIP } from "./constants";

interface Props {
    show?: boolean;
    onHide?: () => void;
    onExited?: () => void;
    role: AccountRole | null;
    isSubmitDisabled: boolean;
    isSubmitting: boolean;
    onSubmit: () => void;
    children: ReactNode;
}

export const ReassignRoleModalShell = ({
    show,
    onHide,
    onExited,
    role,
    isSubmitDisabled,
    isSubmitting,
    onSubmit,
    children,
}: Props) => (
    <PlainModal show={show} onHide={onHide} onExited={onExited} size="md">
        <StandardModalHeader>
            <HStack gap={8} align="center">
                <span>Reassign role</span>
                <Tooltip content={REASSIGN_ROLE_OUTCOME_TOOLTIP}>
                    <Button
                        type="button"
                        variant="ghost"
                        size="md"
                        iconOnly
                        aria-label="About reassign role"
                    >
                        <InfoIcon aria-hidden />
                    </Button>
                </Tooltip>
            </HStack>
        </StandardModalHeader>
        <VStack gap={16}>
            {role !== null && (
                <p className="mb-0">{ACCOUNT_ROLE_COPY[role].description}</p>
            )}
            {children}
            <StandardModalFooter>
                <Button
                    type="button"
                    variant="secondary"
                    onClick={onHide}
                    size="xl"
                    disabled={isSubmitting}
                >
                    Cancel
                </Button>
                <ButtonWithLoader
                    type="button"
                    variant="primary"
                    size="xl"
                    loading={isSubmitting}
                    disabled={isSubmitDisabled || isSubmitting}
                    onClick={onSubmit}
                >
                    Reassign
                </ButtonWithLoader>
            </StandardModalFooter>
        </VStack>
    </PlainModal>
);
